module.exports = __webpack_public_path__ + "static/media/webfont.cc475bce.ttf";